import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
} from '@chakra-ui/react';
import { SharedDisclosureProps } from '../types';
import { TrackerConfig } from './TrackerConfig';
import { EntityType } from '@texas/api/endpoints/trackerApi';
import { useTranslation } from 'react-i18next';
import { entityTypeFriendlyName } from './translations';
import { usePortalRefValue } from '@texas/hooks/usePortalRef';

interface Props extends SharedDisclosureProps {
  entityId: number;
  entityType: EntityType;
  children: React.ReactNode;
}

export function TrackerPopover({
  isOpen,
  onClose,
  entityId,
  entityType,
  children,
}: Props) {
  const { t } = useTranslation();
  const { ref } = usePortalRefValue();

  return (
    <Popover isOpen={isOpen} onClose={onClose} isLazy={true}>
      <PopoverTrigger>{children}</PopoverTrigger>
      <Portal containerRef={ref}>
        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader>
            {t('tracking.trackType', {
              type: entityTypeFriendlyName(t, entityType),
            })}
          </PopoverHeader>
          <Inner entityId={entityId} entityType={entityType} />
        </PopoverContent>
      </Portal>
    </Popover>
  );
}

function Inner({
  entityId,
  entityType,
}: {
  entityId: number;
  entityType: EntityType;
}) {
  return (
    <PopoverBody>
      <TrackerConfig entityId={entityId} entityType={entityType} />
    </PopoverBody>
  );
}
